// src/pages/Login.jsx
import React, { useMemo, useState } from "react";
import { useAuth } from "../components/AuthProvider";

const SITE_ORIGIN = "https://respirarebene.cloud";

export default function Login() {
  const { login, error } = useAuth();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const nextUrl = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("next") || "/";
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    const r = await login(u.trim(), p);
    setBusy(false);
    if (r.ok) {
      window.location.href = nextUrl;
    } else {
      setMsg(error || "Credenziali non valide");
    }
  }

  const createUrl = useMemo(() => {
    // dopo registrazione/OTP, torna all'app (home o next)
    const back = encodeURIComponent(window.location.origin + nextUrl);
    return `${SITE_ORIGIN}/consenso?next=${back}`;
  }, [nextUrl]);

  const recoveryUrl = useMemo(() => {
    // dopo recupero credenziali, può tornare all'app
    const back = encodeURIComponent(window.location.origin + nextUrl);
    return `${SITE_ORIGIN}/recupero?next=${back}`;
  }, [nextUrl]);

  return (
    <div className="max-w-md mx-auto p-6">
      <h1 className="text-xl font-bold mb-4">Accedi</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <div>
          <label className="block mb-1">Nome utente</label>
          <input
            className="w-full border rounded p-2"
            value={u}
            onChange={(e) => setU(e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-1">Password</label>
          <input
            type="password"
            className="w-full border rounded p-2"
            value={p}
            onChange={(e) => setP(e.target.value)}
          />
        </div>

        <button
          className="bg-black text-white px-4 py-2 rounded disabled:opacity-50"
          disabled={busy}
        >
          {busy ? "Accesso..." : "Entra"}
        </button>

        {/* ✅ Recupero credenziali */}
        <div className="pt-1">
          <a
            href={recoveryUrl}
            className="text-sm underline"
            target="_blank"
            rel="noreferrer"
          >
            Hai dimenticato nome utente o password?
          </a>
        </div>
      </form>

      {msg && <p className="mt-3 text-sm text-red-600">{msg}</p>}

      <div className="mt-6">
        <a
          href={createUrl}
          className="inline-flex items-center px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
        >
          Crea account e registrati
        </a>
      </div>
    </div>
  );
}
